import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {userAction, GetUserMemberOfSubjectsAction} from '../action';

const tableId = 'memberOfSubjectsProfile';

function* execute({payload: {tableDataRequest}}: GetUserMemberOfSubjectsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.findLoggedInUserSubjectMembers,
        successAction: userAction.getUserMemberOfSubjectsSuccess,
        tableId,
    }));
}

export function* getUserMemberOfSubjectsSaga(): SagaIterator {
    yield takeLatestF('user/GET_USER_MEMBER_OF_SUBJECTS', execute);
}
